export const GoogleSigninButton = null

export const GoogleSignin = {
  configure: () => null,
  signOut: () => null,
}

export const statusCodes = {
  SIGN_IN_CANCELLED: 'SIGN_IN_CANCELLED',
  PLAY_SERVICES_NOT_AVAILABLE: 'PLAY_SERVICES_NOT_AVAILABLE',
}
